import { AddressLink } from "../components/address/Address";
import { CompanyLogo } from "../components/companyLogo/CompanyLogo";
import { ContactSection } from "../components/contactUs/ContactUs";
import { Footer } from "../components/footer/Footer";
import { Header } from "../components/header/Header";
import NavigationBar from "../components/navigationBar/NavigationBar";

export const FaqPage = ({ title, description }) => (
  <div>
    <Header
      headerTitle={
        <AddressLink
          fontColor={"white"}
          address="12818 BROOKHURST STREET, GARDEN GROVE, CA 92840"
        />
      }
      phoneNumber={"(949) 317-2220"}
      extension={"2"}
      fontColor={"black"}
    />
    <CompanyLogo />
    <NavigationBar />
    <section
      style={{
        padding: "10px 20px",
        backgroundColor: "#edf2f7",
        textAlign: "center",
        letterSpacing: "3px",
      }}
    >
      <h1
        style={{
          fontSize: "3rem",
          fontWeight: "normal",
          fontFamily: '"Playfair Display", Georgia, serif',
          margin: "0.83em 0",
        }}
      >
        <div style={{ flex: "0 1 30vh" }}> {title}</div>
      </h1>
      <hr className="section-divider" />
      <p style={{ fontSize: "1rem", color: "#4a5568" }}>{description}</p>
      <div className="faq-layout">
        <img
          className="faq-photo"
          src="/question.webp"
          alt="Question marks on speech bubbles"
          width={400}
          height={400}
        />
        <div className="faq-copy">
          <h3>How do I get a quote?</h3>
          <p>
            To run a health insurance quote, the following information is
            needed:
          </p>
          <ol>
            <li>Date Of Birth (of every member applying for coverage)</li>
            <li>Permanent Home Zip Code</li>
            <li>
              Projected Adjusted Gross Income for 2021 (if applying for premium
              assistance through Covered CA)
            </li>
          </ol>
          <p>
            Email us at{" "}
            <a className="faq-email" href="mailto:info@itoinsuranceagency.com">
              info@itoinsuranceagency.com
            </a>
          </p>

          <h3>What is Medicare vs. Medicaid?</h3>
          <p>
            Medicare is health insurance coverage for those 65 and over (or
            those under 65 receiving SSDI.) Medicaid (as known as Medi-Cal in
            CA) is for those who are considered low income by each states'
            individual qualifications.
          </p>

          <h3>When can I enroll?</h3>
          <p>
            Every year during the <b>Annual Enrollment Period (AEP)</b> that
            runs:
          </p>
          <ol>
            <li>
              <b>
                Individual & Families (off-exchange)/Covered CA
                Plans(on-exchange)
              </b>{" "}
              - every year between November to January
            </li>
            <li>
              <b>Medicare Advantage & Prescription Drug Plans</b> - every year
              between October 15th-December 7th
            </li>
            <li>
              <b>Employer-Sponsored Plans</b> - dependent upon each individual
              employer
            </li>
            <li>
              <b>Medicaid/Medi-Cal</b> - any time of the year
            </li>
            <li>
              <b>Medicare Supplements</b> - any time of the year but must be
              approved based on past medical records/conditions
            </li>
          </ol>
          <p>
            <b>Special Enrollment Period (SEP)</b>
          </p>
          <p>
            Under{" "}
            <b>
              Individual & Families (off-exchange)/Covered CA Plans(on-exchange)
            </b>
            , SEP is available the rest of the year by qualifying for a special
            life event, such as:
          </p>
          <ul>
            <li>Having a baby</li>
            <li>Getting married</li>
            <li>Getting divorced</li>
            <li>Moving from plan service area</li>
            <li>Losing employer coverage involuntarily</li>
            <li>Turning 26</li>
            <li>Etc.</li>
          </ul>
          <p>
            Under <b>Medicare Advantage & Prescription Drug Plans</b>, SEP
            includes:
          </p>
          <ul>
            <li>Turning 65 or qualifying for Medicare</li>
            <li>
              Qualifying for Prescription Extra Help, a Medicare Savings
              Program, or Medicaid/Medi-Cal
            </li>
            <li>Moving from plan service area</li>
            <li>Retiring from employer coverage</li>
            <li>
              Medicare Advantage Open Enrollment Period (OEP)- from January
              through March
            </li>
            <li>
              Eligible for Chronic Plan based on conditions such as diabetes,
              heart/lung disease, etc.
            </li>
          </ul>

          <h3>Do I qualify?</h3>
          <p>
            Since the implementation of the Affordable Cares Act (ACA) there are
            no pre-existing conditions for the following:
          </p>
          <ol>
            <li>
              <b>Individual & Families/Covered CA Plans</b>
            </li>
            <li>
              <b>Employer-Sponsored Plans</b>
            </li>
            <li>
              <b>Medicaid/Medi-Cal</b>
            </li>
          </ol>
          <p>
            Under Medicare, the following also do not have pre-existing
            conditions:
          </p>
          <ol>
            <li>
              <b>Medicare Advantages</b>
            </li>
            <li>
              <b>Prescription Drug Plans</b>
            </li>
          </ol>
          <p>
            Except during the Initial Enrollment Period for those newly eligible
            for Medicare, <b>Medicare Supplements/Medigap plans</b> applications
            do go under review and require approval based on the applicant's
            medical records and history.
          </p>

          <h3>Is there still a penalty for not having health coverage?</h3>
          <p>
            At the federal level, the health insurance penalty no longer
            applies. But the state of California (alongside a couple of other
            states) chose to continue to implement the penalty to its state
            residents.
          </p>
          <p>"Starting in 2020, California residents must either:</p>
          <ul>
            <li>Have qualifying health insurance coverage, or</li>
            <li>Pay a penalty when filing a state tax return, or</li>
            <li>Get an exemption from the requirement to have coverage.</li>
          </ul>
          <p>
            The penalty for not having coverage the entire year will be at least
            $750 per adult and $375 per dependent child under 18 in the
            household when you file your 2020 state income tax return in 2021. A
            family of four that goes uninsured for the whole year would face a
            penalty of at least $2,250.
          </p>
          <p>
            The penalty will be applied by the California Franchise Tax Board.
            For information about the penalty, including the amount your family
            could owe for not having coverage, visit the Franchise Tax Board’s
            website and use their Penalty Estimator Tool."
          </p>
          <p>Click here for the original resource.</p>

          <h3>
            What is excluded from coverage on a medical health insurance plan?
          </h3>
          <p>
            Other than for minors under 18, health insurance plans only cover
            medical services such as doctor/specialist visits, preventative
            services, x-rays, surgery, hospital, ambulance, etc.
          </p>
          <p>
            Dental, vision, acupuncture, chiropractic care, etc. are not covered
            benefits in most cases. Additional stand-alone plans must be added
            to cover these benefits.
          </p>
        </div>
      </div>
    </section>
    <ContactSection
      phoneNumber={"(949) 317-2220"}
      extension={"2"}
      email={"info@itoinsuranceagency.com"}
      fax={"(949) 301-9611"}
    />
    <Footer />
  </div>
);
